import Form from "./Form";
import Canvas from "./Canvas";
import { useState } from "react";
import styled from "styled-components";

const wallNumberExtractions = (stack) => {
  let array = [];
  stack.forEach((e) => array.push(e.id));
  return array;
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0;
  @media screen and (min-width: 1200px) {
    padding: 10px;
  }
`;

const FormContainer = styled.div`
  display: none;
  padding: 10px;
  margin: 0;
  width: 15%;
  @media screen and (min-width: 1200px) {
    display: block;
  }
`;

const CanvasContainer = styled.div`
  width: 100%;
  @media screen and (min-width: 1200px) {
    width: 83%;
  }
`;

const YurtControl = ({
  handleYurtTraitChange,
  yurtTrait,
  handleWallChange,
  wallTrait,
  pixels,
  handleStackChange,
  setTabIndex,
  printAll,
  handleMasterWallChange,
  stackHeights,
}) => {
  const [editYurt, setEditYurt] = useState(false);
  const [stackEdit, setStackEdit] = useState(false);
  const [stackArray, setStackArray] = useState(
    wallNumberExtractions(yurtTrait.stack)
  );

  const handleEditYurt = () => {
    setEditYurt(!editYurt);
    setStackEdit(false);
  };

  const handleStackEdit = () => {
    setEditYurt(false);
    if (stackEdit) {
      handleStackChange(stackArray);
    }
    setStackEdit(!stackEdit);
  };

  return (
    <Container>
      <FormContainer>
        <Form
          handleYurtTraitChange={handleYurtTraitChange}
          trait={yurtTrait}
          pixels={pixels}
          editYurt={editYurt}
          handleEditYurt={handleEditYurt}
          stackEdit={stackEdit}
          handleStackEdit={handleStackEdit}
          printAll={printAll}
          handleWallChange={handleWallChange}
          walls={wallTrait}
          handleMasterWallChange={handleMasterWallChange}
        />
      </FormContainer>
      <CanvasContainer>
        <Canvas
          handleYurtTraitChange={handleYurtTraitChange}
          yurtTrait={yurtTrait}
          wallTrait={wallTrait}
          handleWallChange={handleWallChange}
          pixels={pixels}
          editYurt={editYurt}
          stackEdit={stackEdit}
          stackArray={stackArray}
          setStackArray={setStackArray}
          setTabIndex={setTabIndex}
          stackHeights={stackHeights}
        />
      </CanvasContainer>
    </Container>
  );
};

export default YurtControl;
